// axiosInstance.js
import { sessionId, loginId, userSessionId, userSessionRefreshed } from '../config';
import { baseApiUrl } from '../helpers/constants.js';
import axios from 'axios';

let isRefreshing = false;
let failedQueue = [];
let axiosInstance = null;

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

export const getAxiosWithHeaders = () => {
  if (axiosInstance) return axiosInstance;

  axiosInstance = axios.create({
    baseURL: baseApiUrl,
    withCredentials: true,

    headers: {
      'Content-Type': 'application/json',
      Ssip: '',
      Cartconfig: '',
      Appname: '',
    },
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      const token = getUserSessionAccessToken();
      if (token) config.headers.Token = token;
      return config;
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;

      if (error?.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        // const refreshToken = localStorage.getItem('surity-refresh-token');

        // if (refreshToken) {
        try {
          const response = await axios.post(
            `${baseApiUrl}/client-project/refresh-token`,
            {},
            { withCredentials: true }
          );

          const newAccessToken = response?.data?.accessToken;
          // const newRefreshToken = response?.data?.refreshToken;

          setSessionAccessToken(newAccessToken);
          // setSessionRefreshedToken(newRefreshToken);

          axiosInstance.defaults.headers.common.Token = newAccessToken;

          originalRequest.headers.Token = newAccessToken;
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          console.log('refresh token failed:', refreshError);
          removeLoginSession();
          removeUserSessionId();
          window.location.href = '/sign-in';
          return Promise.reject(refreshError);
        }
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export const setSession = (data) => setStorageJSON(sessionId, data);
export const getSession = () => getStorageJSON(sessionId);

export const setLoginSession = (data) => setStorageJSON(loginId, data);
export const getLoginSession = () => getStorageJSON(loginId);

export const setSessionAccessToken = (data) => setStorageString(userSessionId, data);
export const getUserSessionAccessToken = () => getStorageString(userSessionId);

export const setSessionRefreshedToken = (data) => setStorageString(userSessionRefreshed, data);
export const getUserSessionRefreshedToken = () => getStorageString(userSessionRefreshed);

export const setStorageString = (key, string) => localStorage.setItem(key, string);

// Get string from storage
export const getStorageString = (key) => {
  if (localStorage.getItem(key)) {
    return localStorage.getItem(key);
  } else {
    return null;
  }
};

export const setStorageJSON = (key, object) => localStorage.setItem(key, JSON.stringify(object));

export const getStorageJSON = (key) => {
  try {
    const item = localStorage.getItem(key);
    if (item !== null && item !== undefined) {
      const data = JSON.parse(item);
      if (Object.keys(data)) {
        return data;
      } else return null;
    }
    return null;
  } catch (error) {
    console.error(`Error parsing JSON from localStorage for key ${key}:`, error);
    return null;
  }
};

export const removeSession = () => {
  removeStorage(sessionId);
};

export const removeLoginSession = () => {
  removeStorage(loginId);
};

export const removeUserSessionId = () => {
  removeStorage(userSessionId);
};

export const removeStorage = (key) => localStorage.removeItem(key);
